import { AppConfig, AppSource } from './appConfig.provider';

const APP_SOURCE_TO_TITLE: Partial<Record<AppSource, string>> = {
  [AppSource.Actuar]: 'Actuar',
  [AppSource.Treino]: 'Treino',
  [AppSource.Afig]: 'AFIG',
  [AppSource.FacilFit]: 'FácilFit',
  [AppSource.PagueLa]: 'Pague.lá',
  [AppSource.Ediz]: 'Ediz',
  [AppSource.Tickou]: 'Tickou',
  [AppSource.EdizApp]: 'EdizApp',
  [AppSource.TickouApp]: 'TickouApp',
};

/** AppSource from config. Each app in libs/apps sets appSource explicitly. */
export const resolveEffectiveAppSource = (config: AppConfig): AppSource =>
  config.appSource;

/** Origin string for auth/API (e.g. "Actuar", "FacilFit"). */
export const resolveOriginByConfig = (config: AppConfig): string =>
  AppSource[config.appSource];

/** Whether the app is the Ediz guardian app (ediz-family). */
const isEdizFamily = (config: AppConfig): boolean =>
  config.appSource === AppSource.EdizApp;

/**
 * Origins the running app answers for, as the comma-separated list the backend
 * splits. The guardian app answers for both Ediz origins, since a person can hold
 * an account under either source. Ediz management and every other brand keep
 * answering for themselves alone.
 */
export const resolveOriginsByConfig = (config: AppConfig): string =>
  isEdizFamily(config)
    ? [AppSource[AppSource.Ediz], AppSource[AppSource.EdizApp]].join(',')
    : resolveOriginByConfig(config);

/** Auth origin slug: "actuar" | "facilfit" | "ediz" | "tickou". */
export type TAuthOrigin =
  | 'actuar'
  | 'facilfit'
  | 'ediz'
  | 'tickou'
  | 'edizapp'
  | 'tickouapp';

export const resolveAuthOrigin = (config: AppConfig): TAuthOrigin =>
  resolveOriginByConfig(config).toLowerCase() as TAuthOrigin;

/**
 * Auth origins for the login payload, in slug form and comma-separated — the
 * guardian app logs in for both Ediz origins. Same rule as {@link resolveOriginsByConfig}.
 */
export const resolveAuthOrigins = (
  config: AppConfig,
): TAuthOrigin | 'ediz,edizapp' =>
  isEdizFamily(config) ? 'ediz,edizapp' : resolveAuthOrigin(config);

export const resolveBrandTitle = (config?: AppConfig | null): string =>
  config ? (APP_SOURCE_TO_TITLE[config.appSource] ?? 'Actuar') : 'Actuar';
